export const NAVIGATION = [
  { id: "billing", icon: "billing", name: "Billing", to: "MemberBilling", color: "#151718" },
  { id: "profile", icon: "navigation/profile", name: "Profile", to: "MemberProfile", color: "#151718" },
  { id: "logout", icon: "navigation/logout", name: "Logout", to: "Logout", color: "#151718" },
];
